import React, { Fragment } from 'react';
import { CardFooter } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import { Submit, Cancel } from '../../../../Constant';

const FooterCard = ({ footerClass, btncolor }) => {
  return (
    <Fragment>
      <CardFooter className={footerClass}>
        <Btn color='primary' className='m-r-10' type='submit'>
          {Submit}
        </Btn>
        <Btn color='secondary' type='submit'>
          {Cancel}
        </Btn>
      </CardFooter>
    </Fragment>
  );
};

export default FooterCard;
